import AMPLITUDE_EVENT_PROPERTIES from '../../consts/amplitude/amplitudeEventProperties';
import AMPLITUDE_EVENT_TYPES from '../../consts/amplitude/amplitudeEventTypes';
import AMPLITUDE_EVENT_VALUES from '../../consts/amplitude/amplitudeEventValues';
import productRegistrationStatusService from '../product/productRegistrationStatusService';
import amplitude from './amplitude';

const trackRegistrationStarted = (isHolder) => {
    amplitude.trackProductEvent({
        isHolder,
        eventType: AMPLITUDE_EVENT_TYPES.REGISTRATION_STARTED,
    });
};

const trackRegistrationCompleted = (isHolder) => {
    amplitude.trackProductEvent({
        isHolder,
        eventType: AMPLITUDE_EVENT_TYPES.REGISTRATION_COMPLETED,
        properties: {
            [AMPLITUDE_EVENT_PROPERTIES.SUCCESS]: true,
        },
    });
};

const trackRegistrationIccError = ({isHolder, error}) => {
    const errorMessage = productRegistrationStatusService.getFailedProductRegistrationErrorMessage(error);

    amplitude.trackProductEvent({
        isHolder,
        eventType: AMPLITUDE_EVENT_TYPES.REGISTRATION_COMPLETED,
        properties: {
            [AMPLITUDE_EVENT_PROPERTIES.SUCCESS]: false,
            [AMPLITUDE_EVENT_PROPERTIES.ERROR_CODE]: errorMessage,
        },
    });
};

const trackRegistrationGamError = (isHolder) => {
    amplitude.trackProductEvent({
        isHolder,
        eventType: AMPLITUDE_EVENT_TYPES.REGISTRATION_COMPLETED,
        properties: {
            [AMPLITUDE_EVENT_PROPERTIES.SUCCESS]: false,
            [AMPLITUDE_EVENT_PROPERTIES.ERROR_CODE]: AMPLITUDE_EVENT_VALUES.GENERAL_REGISTRATION_ERROR,
        },
    });
};

export default {
    trackRegistrationStarted,
    trackRegistrationCompleted,
    trackRegistrationIccError,
    trackRegistrationGamError,
};
